/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DxContextMenuComponent, DxTreeViewComponent, DxTreeViewModule, DxContextMenuModule } from 'devextreme-angular';
import { Item as TreeViewItem } from 'devextreme/ui/tree_view';
import { ExportContainer } from '../../models/export-container';
import { ExportItems } from '../../models/exportItems';
import { DeveloperService } from '../../services/developer.service';
import {
    DataMapper,
    AssemblyArtifactNode,
    ConfigKeyNode,
    DistroNode,
    DocConfigNode,
    ExceptionTypeNode,
    ExportNode,
    FormatNode,
    ItineraryStepNode,
    InitializeStepNode,
    TransportTypeNode,
    TrackingFieldNode,
    XmlArtifactNode,
    FileNamingTypeNode,
    XmlPropertyPromotionFilterNode,
    FormatTypeNode, DuplicateCheckNode,
    ContentTypeGroupNode,
    DocumentTypeClassifierResolverNode,
    DocumentTypeClassifierNode,
    ScheduleTriggerNode,
    ScheduleItemNode,
    BatchingConfigurationNode,
    DocumentConfigOutBatcherNode,
    IdentificationTypeNode,
    IdentificationTypeQualifierNode,
    ConcurrencyKeyNode
} from '../../helpers/export-node';
import { ToastService, ToastType } from 'src/app/shared/toast/toast.service';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { DeveloperArtifactService } from '../../services/developer-artifact.service';
import { AssemblyArtifact, XmlArtifact } from '../../models/artifact';
import { DxTemplateModule } from 'devextreme-angular/core';

export interface MenuItem {
    id: string;
    text: string;
}

@Component({
    selector: 'app-developer-export-source',
    templateUrl: './developer-export-source.component.html',
    styleUrls: ['./developer-export-source.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxTreeViewModule, DxTemplateModule, DxContextMenuModule]
})
export class DeveloperExportSourceComponent implements AfterViewInit {
    @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;
    @ViewChild(DxContextMenuComponent) contextMenu: DxContextMenuComponent;
    @Input() includeArtifacts = false;
    @Input({ required: true }) dataMapper: DataMapper;

    menuItems: MenuItem[] = [
        { id: 'include', text: 'Include' },
        { id: 'exclude', text: 'Exclude' },
    ];
    itemForContextMenu: ExportNode = null;

    selectedNodeCount = 0;
    private selectedNodeKeys: number[] = [];    
    private seenIdsByType = new Map<string, Set<any>>();

    rootConfigKey: TreeViewItem = { text: 'Configuration keys', items: [] };
    rootDocConfig: TreeViewItem = { text: 'Document configurations', items: [] };
    rootDocType: TreeViewItem = { text: 'Document types', items: [] };
    rootErrorCode: TreeViewItem = { text: 'Error codes', items: [] };
    rootFormat: TreeViewItem = { text: 'Formats', items: [] };
    rootFormatType: TreeViewItem = { text: 'Format types', items: [] };
    rootIdTypes: TreeViewItem = { text: 'Identification type qualifiers', items: [] };
    rootItinerarySteps: TreeViewItem = { text: 'Itinerary steps', items: [] };
    rootInitializeSteps: TreeViewItem = { text: 'Initialize steps', items: [] };
    rootTransportTypes: TreeViewItem = { text: 'Transport types', items: [] };
    rootTrackField: TreeViewItem = { text: 'Tracking fields', items: [] };
    rootVersion: TreeViewItem = { text: 'Variant versions', items: [] };
    rootVariant: TreeViewItem = { text: 'Variants', items: [] };
    rootFileNamingTypes: TreeViewItem = { text: 'File naming types', items: [] };
    rootAssemblyArtifacts: TreeViewItem = { text: 'Assembly artifacts', items: [] };
    rootXmlArtifacts: TreeViewItem = { text: 'Xml artifacts', items: [] };
    rootPromotionFilters: TreeViewItem = { text: 'Xml property promotions', items: [] };
    rootDuplicateChecks: TreeViewItem = { text: 'Duplicate checks', items: [] };
    rootContentTypeGroups: TreeViewItem = { text: 'Content type groups', items: [] };
    rootDocumentTypeClassifierResolvers: TreeViewItem = { text: 'Document type classifier resolvers', items: [] };
    rootDocumentTypeClassifiers: TreeViewItem = { text: 'Document type classifiers', items: [] };
    rootBatchingConfigurations: TreeViewItem = { text: 'Batching configurations', items: [] };
    rootScheduleItems: TreeViewItem = { text: 'Schedule items', items: [] };
    rootScheduleTriggers: TreeViewItem = { text: 'Schedule triggers', items: [] };
    rootDocumentConfigOutBatchers: TreeViewItem = { text: 'Document config out batchers', items: [] };
    rootIdentificationTypes: TreeViewItem = { text: 'Identification types', items: [] };
    rootIdentificationTypeQualifiers: TreeViewItem = { text: 'Identification type qualifiers', items: [] };
    rootConcurrencyKeys: TreeViewItem = { text: 'Concurrency keys', items: [] };

    assemblyArtifactDependencyInput: AssemblyArtifact[];
    xmlArtifactDependencyInput: XmlArtifact[];

    rootNodes: TreeViewItem[] = [
        this.rootConfigKey,
        this.rootDocConfig,
        this.rootDocType,
        this.rootErrorCode,
        this.rootFormat,
        this.rootFormatType,
        this.rootIdTypes,
        this.rootItinerarySteps,
        this.rootInitializeSteps,
        this.rootTransportTypes,
        this.rootTrackField,
        this.rootVersion,
        this.rootVariant,
        this.rootFileNamingTypes,
        this.rootAssemblyArtifacts,
        this.rootXmlArtifacts,
        this.rootPromotionFilters,
        this.rootDuplicateChecks,
        this.rootContentTypeGroups,
        this.rootDocumentTypeClassifierResolvers,
        this.rootDocumentTypeClassifiers,
        this.rootBatchingConfigurations,
        this.rootScheduleItems,
        this.rootScheduleTriggers,
        this.rootDocumentConfigOutBatchers,
        this.rootIdentificationTypes,
        this.rootIdentificationTypeQualifiers,
        this.rootConcurrencyKeys,
    ].sort((a, b) => a.text.localeCompare(b.text));

    explicitNodes: ExportItems = {
        documentTypes: [],
        documentConfigurations: [],
        configurationKeys: [],
        trackingFields: [],
        exceptionTypes: [],
        itinerarySteps: [],
        initializeSteps: [],
        transportTypes: [],
        fileNamingTypes: [],
        xmlArtifacts: [],
        assemblyArtifacts: [],
        promotionFilters: [],
        duplicateChecks: [],
        contentTypeGroups: [],
        documentTypeClassifierResolvers: [],
        documentTypeClassifiers: [],
        batchingConfigurations: [],
        identificationTypes: []
    };

    constructor(
        private developerService: DeveloperService,
        private loadingPanelService: LoadingPanelService,
        private toastService: ToastService,
        private developerArtifactService: DeveloperArtifactService
    ) { }

    ngAfterViewInit(): void {
        void this.regenerateTreeViewItems();
    }

    onItemRendered(ev): void {
        // Mark for disable
        if (this.isImplicitNode(ev.node)) {
            ev.itemElement.addClass('disable-checkbox');
        }
    }

    onContentReady(ev: any): void {
        ev.element.find('.disable-checkbox').parent().find('.dx-checkbox').addClass('hide-checkbox-only');
    }

    onShowing(ev: any): void {
        const ctxMenu = this.contextMenu.instance;
        ev.cancel = !ctxMenu.option('items[0].visible') && !ctxMenu.option('items[1].visible');
    }

    onItemContextMenu(ev: any): void {
        const ctxMenu = this.contextMenu.instance;
        const selectedItem: ExportNode = ev.itemData.exportNode;
        this.itemForContextMenu = selectedItem;

        const includeVisible = !!selectedItem && selectedItem.isExcludable && selectedItem.isExcluded;
        const excludeVisible = !!selectedItem && selectedItem.isExcludable && !selectedItem.showExcluded;

        ctxMenu.option('items[0].visible', includeVisible);
        ctxMenu.option('items[1].visible', excludeVisible);
    }

    onContextMenuItemClick(ev: any): void {
        const menuItem: MenuItem = ev.itemData;

        switch (menuItem.id) {
            case 'include':
                this.itemForContextMenu.isExcluded = false;
                break;

            case 'exclude':
                this.itemForContextMenu.isExcluded = true;
                break;
        }
    }

    private updateSelectedNodes(): void {
        this.selectedNodeKeys = this.treeView.instance.getSelectedNodeKeys();
        this.selectedNodeCount = this.selectedNodeKeys.length;
    }

    onSelectionChanged(_ev: any): void {
        const oldKeys = this.selectedNodeKeys;
        this.updateSelectedNodes();
        const newKeys = this.selectedNodeKeys;

        const selected = newKeys.filter(e => oldKeys.indexOf(e) < 0);
        if (selected.length) {
            this.onNodesSelected(selected);
        }

        const unselected = oldKeys.filter(e => newKeys.indexOf(e) < 0);
        if (unselected.length) {
            this.onNodesUnselected(unselected);
        }
    }

    onNodesSelected(nodeKeys: any[]): void {
        const all = this.treeView.instance.getNodes();
        nodeKeys.forEach(key => {
            const node = this.findNode(all, key);
            if (node) {
                if (!this.isImplicitNode(node)) {
                    const parent = this.getParent(node);
                    if (!this.isRootNode(parent)) {
                        // This will generate a new event for the parent and that way it will
                        // iterate all the way to the top, excluding the very topmost node.
                        this.treeView.instance.selectItem(this.getKey(parent));
                    }
                }
            }
        });
    }

    onNodesUnselected(nodeKeys: any[]): void {
        const all = this.treeView.instance.getNodes();
        nodeKeys.forEach(key => {
            const node = this.findNode(all, key);
            if (!this.isRootNode(node)) {
                this.unselectAllChildren(node);
            }
        });
    }

    private getKey(node: TreeViewItem): any {
        return (node as any)?.key;
    }

    private getParent(node: TreeViewItem): TreeViewItem {
        return (node as any)?.parent;
    }

    private isRootNode(node: TreeViewItem): boolean {
        return node && !this.getParent(node);
    }

    public isImplicitNode(node: TreeViewItem): boolean {
        const en = this.exportNode(node);
        return !!en && !en.isExplicit;
    }

    public isExcludedNode(node: TreeViewItem): boolean {
        const en = this.exportNode(node);
        return !!en && en.showExcluded;
    }

    private unselectAllChildren(node: TreeViewItem): void {
        if (node?.items) {
            node.items.forEach(e => {
                this.treeView.instance.unselectItem(this.getKey(e));
                this.unselectAllChildren(e);
            });
        }
    }

    private findNode(nodes: TreeViewItem[], key: any): TreeViewItem | undefined {
        for (const node of nodes) {
            if (this.getKey(node) === key) {
                return node;
            }
            if (node.items && node.items.length > 0) {
                const found = this.findNode(node.items, key);
                if (found) {
                    return found;
                }
            }
        }
        return undefined;
    }

    get hasExportItems(): boolean {
        for (const property in this.explicitNodes) {
            if (Object.prototype.hasOwnProperty.call(this.explicitNodes, property)) {
                const nodes: [] = this.explicitNodes[property];
                if (nodes.length > 0) { return true; }
            }
        }
        return false;
    }

    exportNode(item: TreeViewItem): ExportNode {
        return (item as any).exportNode || (item as any).itemData?.exportNode;
    }

    private distinctAndOrdered(treeViewItems: TreeViewItem[]): TreeViewItem[] {
        return treeViewItems
            .filter((item, idx, arr) => idx === arr.findIndex(e => this.exportNode(e)?.id === this.exportNode(item)?.id))
            .sort((a, b) => a.text.localeCompare(b.text));
    }

    private addNodes(root: TreeViewItem, items: ExportNode[]): void {
        if (items?.length) {

            let anyNewExplicit = false;
            items.forEach(item => {
                anyNewExplicit = anyNewExplicit || (item.isNew && item.isExplicit);
                if (!item.isExplicit) {
                    item.isNew = false;
                }
            });
            if (anyNewExplicit) {
                root.expanded = true;
            }
            // if(items.length > 0){
            //     root.items.push(...items.map(exportNode => exportNode.treeViewItem));
            // }
            items.forEach(item => {
                if ((item as AssemblyArtifactNode)) {
                    if ((item as AssemblyArtifactNode).data) {
                        root.items.push(item.treeViewItem);
                    }
                }
                else if ((item as XmlArtifactNode)) {
                    if ((item as XmlArtifactNode).data) {
                        root.items.push(item.treeViewItem);
                    }
                }
                else if (item.data) {
                    root.items.push(item.treeViewItem);
                }
            });
            root.items = this.distinctAndOrdered(root.items);
        }
    }

    // This helps to prevent circular refferences.
    // Filters out items that have already been seen based on their id and the provided typeKey, and adds the ids of the new items to the seen set.
    private filterUnseen<T extends { id?: any }>(items: T[], typeKey: string): T[] {
        if (!items?.length) {
            return [];
        }

        let seenSet = this.seenIdsByType.get(typeKey);
        if (!seenSet) {
            seenSet = new Set<any>();
            this.seenIdsByType.set(typeKey, seenSet);
        }

        return items.filter(item => {
            const id = item?.id;
            if (id === null || id === undefined || id === '') {
                return false;
            }
            if (seenSet.has(id)) {
                return false;
            }
            seenSet.add(id);
            return true;
        });
    }

    private addFormatNodes(items: FormatNode[]): void {
        if (items?.length) {
            this.addFormatTypeNodes(items.map(item => item.formatTypeNode));
            this.addNodes(this.rootFormat, items);
        }
    }

    private addFormatTypeNodes(items: FormatTypeNode[]): void {
        if (items?.length) {
            this.addAssemblyArtifactNodes(items.filter(item => item.probeArtifact).map(item => item.probeArtifact));
            this.addInitializeStepNodes(items.filter(item => item.initStepNode).map(item => item.initStepNode));
            this.addNodes(this.rootFormatType, items);
            this.addConfigKeyNodes(items.flatMap(item => item.configurationKeyNodes ?? []));
        }
    }

    private addDistroNodes(items: DistroNode[]): void {
        if (items?.length) {
            this.addFileNamingTypeNodes([].concat(...items.filter(item => item.isExplicit).map(item => item.fileNamingTypeNodes)));
            this.addXmlArtifactNodes(items.filter(item => item.CdmSchemaArtifact).map(item => item.CdmSchemaArtifact));
            this.addXmlArtifactNodes(items.filter(item => item.CdmStylesheetArtifact).map(item => item.CdmStylesheetArtifact));
            this.addNodes(this.rootDocType, items);
            this.addConfigKeyNodes(items.flatMap(item => item.configurationKeyNodes ?? []));
        }
    }

    private addDocConfigNodes(items: DocConfigNode[]): void {
        const docConfigs = this.filterUnseen(items, 'DocConfig');

        if (docConfigs.length) {
            this.addFormatNodes(docConfigs.map(item => item.formatNode));
            this.addDistroNodes(docConfigs.map(item => item.distroNode));
            this.addNodes(this.rootVariant, docConfigs.map(item => item.variantNode));
            this.addNodes(this.rootVersion, docConfigs.map(item => item.versionNode));
            this.addDocumentConfigOutBatchers(docConfigs.flatMap(item => item.documentConfigOutBatchers));
            this.addNodes(this.rootDocConfig, docConfigs);
            this.addItineraryStepNodes(docConfigs.flatMap(item => item.itineraryStepNodes));
            this.addConfigKeyNodes(docConfigs.flatMap(item => item.configurationKeyNodes ?? []));
        }
    }

    private addTrackingFieldNodes(items: TrackingFieldNode[]): void {
        if (items?.length) {
            this.addDistroNodes(items.map(item => item.distroNode));
            this.addNodes(this.rootTrackField, items);
        }
    }

    private addConfigKeyNodes(items: ConfigKeyNode[]): void {
        const configKeys = this.filterUnseen(items, 'ConfigKey');
        if (configKeys.length) {
            this.addDocConfigNodes(configKeys.flatMap(item => (item.docConfigNode && item.data?.DynamicForeignKey) ? [item.docConfigNode] : []));
            this.addDistroNodes(configKeys.flatMap(item => (item.distroNode && item.data?.DynamicForeignKey) ? [item.distroNode] : []));
            this.addNodes(this.rootFormatType, configKeys.flatMap(item => (item.formatTypeNode && item.data?.DynamicForeignKey) ? [item.formatTypeNode] : []));
            this.addNodes(this.rootConfigKey, configKeys);
        }
    }

    private addExceptionTypeNodes(items: ExceptionTypeNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootErrorCode, items);
        }
    }
    private addFileNamingTypeNodes(items: FileNamingTypeNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootFileNamingTypes, items);
        }
    }
    private addXmlArtifactNodes(items: XmlArtifactNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootXmlArtifacts, items);
            items.flatMap(item => item.data).forEach(item => this.xmlArtifactDependencyInput.push(item));
        }
    }
    private addAssemblyArtifactNodes(items: AssemblyArtifactNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootAssemblyArtifacts, items);
            items.flatMap(item => item.data).forEach(item => this.assemblyArtifactDependencyInput.push(item));
        }
    }
    private addItineraryStepNodes(items: ItineraryStepNode[]): void {
        if (items?.length) {
            this.addAssemblyArtifactNodes(items.flatMap(item => item.assemblyArtifact));
            this.addNodes(this.rootItinerarySteps, items);
        }
    }
    private addInitializeStepNodes(items: InitializeStepNode[]): void {
        if (items?.length) {
            this.addAssemblyArtifactNodes(items.flatMap(item => item.assemblyArtifact));
            this.addNodes(this.rootInitializeSteps, items);
        }
    }
    private addTransportTypeNodes(items: TransportTypeNode[]): void {
        if (items?.length) {
            this.addAssemblyArtifactNodes(items.flatMap(item => item.assemblyArtifact));
            this.addNodes(this.rootTransportTypes, items);
        }
    }
    private addPromotionFilterNodes(items: XmlPropertyPromotionFilterNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootPromotionFilters, items);
        }
    }

    private addDuplicateCheckNodes(items: DuplicateCheckNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootDuplicateChecks, items);
        }
    }

    private addDContentTypeGroupNodes(items: ContentTypeGroupNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootContentTypeGroups, items);
        }
    }


    private addDocumentTypeClassifierResolverNodes(items: DocumentTypeClassifierResolverNode[]): void {
        if (items?.length) {
            this.addAssemblyArtifactNodes(items.flatMap(item => item.assemblyArtifact));
            this.addDContentTypeGroupNodes(items.flatMap(item => (item.contentTypeGroupNode && item.data.ContentTypeGroupId) ? item.contentTypeGroupNode : []));
            this.addNodes(this.rootDocumentTypeClassifierResolvers, items);
        }
    }

    private addDocumentTypeClassifierNodes(items: DocumentTypeClassifierNode[]): void {
        if (items?.length) {
            this.addDocConfigNodes(items.flatMap(item => (item.docConfigNode && item.data.DocumentConfigId) ? item.docConfigNode : []));
            this.addDistroNodes(items.flatMap(item => (item.distroNode && item.data.DocumentTypeId) ? item.distroNode : []));
            this.addDocumentTypeClassifierResolverNodes(items.flatMap(item => (item.resolvernode && item.data.DocumentTypeClassifierResolverId) ? item.resolvernode : []));
            this.addAssemblyArtifactNodes(items.flatMap(item => (item.controlArtifact && item.data.ControlMessageInResolverArtifactId) ? item.controlArtifact : []));
            this.addNodes(this.rootDocumentTypeClassifiers, items);
        }
    }

    private addScheduleTriggerNodes(items: ScheduleTriggerNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootScheduleTriggers, items);
        }
    }

    private addScheduleItemNodes(items: ScheduleItemNode[]): void {
        if (items?.length) {
            this.addScheduleTriggerNodes(items.flatMap(item => item.triggers ? item.triggers : []));
            this.addNodes(this.rootScheduleItems, items);
        }
    }

    private addBatchingConfigurationNodes(items: BatchingConfigurationNode[]): void {
        if (items?.length) {
            this.addDistroNodes(items.flatMap(item => (item.distroNode && item.data.DocumentType) ? item.distroNode : []));
            this.addScheduleItemNodes(items.flatMap(item => item.scheduleNode ? item.scheduleNode : []));
            this.addNodes(this.rootBatchingConfigurations, items);
        }
    }

    private addDocumentConfigOutBatchers(items: DocumentConfigOutBatcherNode[]): void {
        if (items?.length) {
            this.addAssemblyArtifactNodes(items.flatMap(item => (item.assemblyArtifact && item.data.ArtifactId) ? item.assemblyArtifact : []));
            this.addNodes(this.rootDocumentConfigOutBatchers, items);
        }
    }

    private addIdentificationTypes(items: IdentificationTypeNode[]): void {
        if (items?.length) {
            this.addIdentificationTypeQualifiers(items.flatMap(item => item.qualifiers ? item.qualifiers : []));
            this.addNodes(this.rootIdentificationTypes, items);
        }
    }

    private addIdentificationTypeQualifiers(items: IdentificationTypeQualifierNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootIdentificationTypeQualifiers, items);
        }
    }

    private addConcurrencyKeys(items: ConcurrencyKeyNode[]): void {
        if (items?.length) {
            this.addNodes(this.rootConcurrencyKeys, items);
        }
    }

    private async regenerateTreeViewItems(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading entity details...');
            this.treeView.items = [];
            this.assemblyArtifactDependencyInput = [];
            this.xmlArtifactDependencyInput = [];
            
            // Empty all root nodes and seenIdsByType
            this.rootNodes.forEach(e => e.items = []);
            this.seenIdsByType.clear();

            // Explicit distro's must come after those with implicit distros
            this.addConfigKeyNodes(this.explicitNodes.configurationKeys);
            this.addDocConfigNodes(this.explicitNodes.documentConfigurations);
            this.addTrackingFieldNodes(this.explicitNodes.trackingFields);
            this.addFileNamingTypeNodes(this.explicitNodes.fileNamingTypes);
            this.addXmlArtifactNodes(this.explicitNodes.xmlArtifacts);
            this.addAssemblyArtifactNodes(this.explicitNodes.assemblyArtifacts);
            this.addDistroNodes(this.explicitNodes.documentTypes);
            this.addExceptionTypeNodes(this.explicitNodes.exceptionTypes);
            this.addItineraryStepNodes(this.explicitNodes.itinerarySteps);
            this.addInitializeStepNodes(this.explicitNodes.initializeSteps);
            this.addTransportTypeNodes(this.explicitNodes.transportTypes);
            this.addPromotionFilterNodes(this.explicitNodes.promotionFilters);
            this.addDuplicateCheckNodes(this.explicitNodes.duplicateChecks);
            this.addDContentTypeGroupNodes(this.explicitNodes.contentTypeGroups);
            this.addDocumentTypeClassifierResolverNodes(this.explicitNodes.documentTypeClassifierResolvers);
            this.addDocumentTypeClassifierNodes(this.explicitNodes.documentTypeClassifiers);
            this.addBatchingConfigurationNodes(this.explicitNodes.batchingConfigurations);
            this.addIdentificationTypes(this.explicitNodes.identificationTypes);

            // Load dependency artifacts
            const newAssemblyArtifactNodes: AssemblyArtifactNode[] = [];
            const newXmlArtifactNodes: XmlArtifactNode[] = [];

            if (this.assemblyArtifactDependencyInput[0]) {
                const assemblyDependencyResult = await this.developerArtifactService.getMultipleAssemblyArtifactDependencies(this.assemblyArtifactDependencyInput.filter(e => e).flatMap(art => art.ArtifactId));
                assemblyDependencyResult.forEach(dep => newAssemblyArtifactNodes.push(new AssemblyArtifactNode(dep, this.dataMapper, false)));
            }

            await Promise.all(this.explicitNodes.documentConfigurations.map(async item => {
                const result = await this.developerArtifactService.getDocumentConfigAssemblyArtifacts(item.data.DocumentConfigId);
                result.forEach(dep => newAssemblyArtifactNodes.push(new AssemblyArtifactNode(dep, this.dataMapper, false)));
            }));

            this.addNodes(this.rootAssemblyArtifacts, newAssemblyArtifactNodes);

            const xmlDependencyResult = await this.developerArtifactService.getMultipleXmlArtifactDependencies(this.xmlArtifactDependencyInput.flatMap(art => art.ArtifactId));
            xmlDependencyResult.forEach(dep => newXmlArtifactNodes.push(new XmlArtifactNode(dep, this.dataMapper, false)));

            await Promise.all(this.explicitNodes.documentConfigurations.map(async item => {
                const result = await this.developerArtifactService.getDocumentConfigXmlArtifacts(item.data.DocumentConfigId);
                result.forEach(dep => newXmlArtifactNodes.push(new XmlArtifactNode(dep, this.dataMapper, false)));
            }));

            this.addNodes(this.rootXmlArtifacts, newXmlArtifactNodes);

            // Hide roots with no content
            this.rootNodes.forEach(e => {
                if (!e.items?.length) {
                    e.expanded = e.visible = false;
                }
                else {
                    e.visible = true;
                }
            });

            this.treeView.items = this.rootNodes;
            this.updateSelectedNodes();
            this.loadingPanelService.hideLoadingPanel();
        }
        catch {
            this.clear();
        }
    }


    private removeExplicitNode(exportNode: ExportNode): void {
        for (const key in this.explicitNodes) {
            if (Object.prototype.hasOwnProperty.call(this.explicitNodes, key)) {
                const rootGroup: ExportNode[] = this.explicitNodes[key];
                const index = rootGroup.findIndex(e => e === exportNode);
                if (index >= 0) {
                    rootGroup.splice(index, 1);
                }
            }
        }
    }

    private resetIsNew(): void {
        // Reset isNew on all existing export nodes
        for (const key in this.explicitNodes) {
            if (Object.prototype.hasOwnProperty.call(this.explicitNodes, key)) {
                const nodes: ExportNode[] = this.explicitNodes[key];
                nodes.forEach(e => e.isNew = false);
            }
        }
    }

    removeSelectedItems(): void {
        this.resetIsNew();

        this.rootNodes.forEach(rootItem => {
            if (rootItem?.items) {
                rootItem.items.filter(e => e.selected).forEach(selectedItem => {
                    const exportNode: ExportNode = this.exportNode(selectedItem);
                    this.removeExplicitNode(exportNode);
                });
            }
        });
        this.treeView.instance.unselectAll();
        void this.regenerateTreeViewItems();
    }

    addExportItems(items: ExportItems): void {
        this.resetIsNew();

        // Add all new nodes that are not already added
        for (const key in items) {
            if (Object.prototype.hasOwnProperty.call(items, key)) {
                const existingItems: ExportNode[] = this.explicitNodes[key];
                const uniqueItems = (items[key] as ExportNode[]).filter(item => existingItems.findIndex(e => e.id === item.id) < 0);
                uniqueItems.forEach(e => { e.isNew = true; });
                existingItems.push(...uniqueItems);
            }
        }

        void this.regenerateTreeViewItems();
    }

    async export(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Generating export file...');

            const exportContainer: ExportContainer = {
                DocumentConfigs: this.explicitNodes.documentConfigurations.map(e => e.id.toString()),
                DistributionObjects: this.explicitNodes.documentTypes.map(e => e.id),
                TrackingFields: this.explicitNodes.trackingFields.map(e => e.id),
                ConfigurationKeys: this.explicitNodes.configurationKeys.map(e => e.id),
                ExceptionTypes: this.explicitNodes.exceptionTypes.map(e => e.id),
                ItinerarySteps: this.explicitNodes.itinerarySteps.filter(e => e.assemblyArtifact.data).map(e => e.id),
                InitializeSteps: this.explicitNodes.initializeSteps.map(e => e.id),
                TransportTypes: this.explicitNodes.transportTypes.map(e => e.id),
                FileNamingTypes: this.explicitNodes.fileNamingTypes.map(e => e.id),
                XmlArtifacts: this.explicitNodes.xmlArtifacts.map(e => e.id),
                AssemblyArtifacts: this.explicitNodes.assemblyArtifacts.map(e => e.id),
                PromotedPropertyFilters: this.explicitNodes.promotionFilters.map(e => e.id),
                DuplicateChecks: this.explicitNodes.duplicateChecks.map(e => e.id),
                ContentTypeGroups: this.explicitNodes.contentTypeGroups.map(e => e.id),
                DocumentTypeClassifierResolvers: this.explicitNodes.documentTypeClassifierResolvers.map(e => e.id),
                DocumentTypeClassifiers: this.explicitNodes.documentTypeClassifiers.map(e => e.id),
                BatchingConfigurations: this.explicitNodes.batchingConfigurations.map(e => e.id),
                IdentificationTypes: this.explicitNodes.identificationTypes.map(e => e.id),
            };

            await this.developerService.export(exportContainer, this.includeArtifacts);

            this.clear();
            this.updateSelectedNodes();
        }
        catch (err) {
            console.log(err);
            this.toastService.showToast('Failed to download export file...', ToastType.error);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    clear(): void {
        for (const key in this.explicitNodes) {
            if (Object.prototype.hasOwnProperty.call(this.explicitNodes, key)) {
                this.explicitNodes[key] = [];
            }
        }
        void this.regenerateTreeViewItems();
    }
}
